import { useScrollReset } from '../hooks/useScrollReset';

const ScrollToTop: React.FC = () => {
  useScrollReset();
  return null;
};

export default ScrollToTop;